import { useMutation } from '@tanstack/react-query';
import savePermissionsSet from '@/API/PermissionsSets/savePermissionsSet';
import savePermission from '@/API/Permissions/savePermission';
import { toast } from 'react-toastify';

const useEditPermissionsSet = (
    permissionsSet,
    accountScope,
    navigate,
    submitData,
) => {
    return useMutation({
        mutationFn: async () => {
            const response = await savePermissionsSet({
                formData: permissionsSet,
                scope: accountScope,
            });

            await Promise.all(
                Object.values(submitData).map((data) =>
                    savePermission({ data }),
                ),
            );

            return response;
        },
        onSuccess: () => {
            toast.success('Permissions set updated successfully');
            navigate('/admins', { state: { index: 2 } });
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.message ||
                    error?.message ||
                    'Failed to update permissions set',
            );
        },
    });
};

export default useEditPermissionsSet;
